import { render } from "./PermissionsField.vue?vue&type=template&id=5703a70e"
import script from "./PermissionsField.vue?vue&type=script&lang=js"
export * from "./PermissionsField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PermissionsField.vue"]])

export default __exports__